import { LOCAL_STORAGE_KEYS } from "../utils/constants";
import { invokeApi } from "../bl_libs/invokeApi";
import { use_e2ee } from "../utils/utils";

/**
 * Partner requests — what partner workspaces have asked DQ for (a solution
 * upgrade, a dashboard, the COS Government Checklist, …), and the approve /
 * decline decision. Every request type goes through the same two endpoints;
 * the API's PARTNER_REQUEST_CATALOG says what each type is and what approving
 * it does (`auto_grant`, `grant_label`, `setup_hint` on each row).
 *
 * Search, filters and paging all run on the server.
 */
export const listPartnerRequests = ({ search = '', status = '', request_type = '', page = 0, rows_per_page = 25 } = {}) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    return invokeApi({
        path: '/admin/partner_requests/list',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { search, status, request_type, page, rows_per_page },
    }, use_e2ee());
};

/** decision_note is required by the server when declining — the partner is emailed it. */
export const decidePartnerRequest = ({ request_id, decision, decision_note = '' }) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    return invokeApi({
        path: '/admin/partner_requests/decide',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { request_id, decision, decision_note },
    }, use_e2ee());
};

/** PartnerRequest.status (PARTNER_REQUEST_STATUS in my-dq-api). */
export const PARTNER_REQUEST_STATUS = {
    PENDING: 0,
    APPROVED: 5,
    DECLINED: 9,
};

export const PARTNER_REQUEST_DECISION = {
    APPROVE: 'approve',
    DECLINE: 'decline',
};

export const STATUS_LABEL = {
    0: 'Pending',
    5: 'Approved',
    9: 'Declined',
};

export const STATUS_COLOR = {
    0: { fg: '#0b5fa5', bg: '#e8f1fa' },
    5: { fg: '#1b6b3a', bg: '#e7f4ec' },
    9: { fg: '#a33224', bg: '#fbecea' },
};

/** Dropdown options. The empty value means "all", which the server ignores. */
export const STATUS_FILTERS = [
    { value: '', label: 'All statuses' },
    { value: String(PARTNER_REQUEST_STATUS.PENDING), label: 'Pending' },
    { value: String(PARTNER_REQUEST_STATUS.APPROVED), label: 'Approved' },
    { value: String(PARTNER_REQUEST_STATUS.DECLINED), label: 'Declined' },
];
